export default "__VITE_ASSET__DdP0fiFp__"